let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bcehj")).then(() => parcelRequire('73mZu'));